<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
<!--      <b-row>-->
<!--        <b-col>-->
<!--          <div-->
<!--            v-if="created"-->
<!--            class="alert alert-success"-->
<!--            role="status">{{ created['brandTitle'] }} {{$t('notifications.created')}}</div>-->
<!--          <div-->
<!--            v-if="updated"-->
<!--            class="alert alert-success"-->
<!--            role="status">{{ updated['brandTitle'] }} {{$t('notifications.updated')}}</div>-->
<!--          <div-->
<!--            v-if="isLoading || deleteLoading"-->
<!--            class="alert alert-info"-->
<!--            role="status">{{$t('alerts.loading')}}...</div>-->
<!--          <div-->
<!--            v-if="error"-->
<!--            class="alert alert-danger"-->
<!--            role="alert">-->
<!--        <span-->
<!--          class="fa fa-exclamation-triangle"-->
<!--          aria-hidden="true"></span> {{ error }}-->
<!--          </div>-->
<!--          <div-->
<!--            v-if="deleteError"-->
<!--            class="alert alert-danger"-->
<!--            role="alert">-->
<!--        <span-->
<!--          class="fa fa-exclamation-triangle"-->
<!--          aria-hidden="true"></span> {{ deleteError }}-->
<!--          </div>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMDeviceModelList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-card-title>{{$t('views.excmdevicemodel.update.title')}}</b-card-title>
            <EXCMDeviceModelForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDeviceModelForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMDeviceModelForm,
    Loader
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceModelUpdate')
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmdevicemodel/update/isLoading',
      error: 'excmdevicemodel/update/error',
      deleteError: 'excmdevicemodel/del/error',
      deleteLoading: 'excmdevicemodel/del/isLoading',
      created: 'excmdevicemodel/create/created',
      deleted: 'excmdevicemodel/del/deleted',
      retrieved: 'excmdevicemodel/update/retrieved',
      updated: 'excmdevicemodel/update/updated',
      violations: 'excmdevicemodel/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDeviceModelList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdevicemodel/create/reset',
      deleteItem: 'excmdevicemodel/del/del',
      delReset: 'excmdevicemodel/del/reset',
      retrieve: 'excmdevicemodel/update/retrieve',
      updateReset: 'excmdevicemodel/update/reset',
      update: 'excmdevicemodel/update/update',
      updateRetrieved: 'excmdevicemodel/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdevicemodel ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
